/**
 * 视口判定统一入口。
 *
 * 浏览器里读 window 尺寸；构建期预渲染（Node）时 window 不存在，
 * 由 src/prerender/dom-shim.js 注入 __SSR_VIEWPORT__ 决定断点，
 * 保证同一份组件树在服务端和客户端首屏得到一致的是否手机版结论。
 */

// 与历史逻辑保持一致：宽度 <= 1200，或者高度大于宽度（横屏手机竖放等场景）都算手机版
export const isPhoneViewport = (width, height) => width <= 1200 || height > width;

export function getViewport() {
  const ssrViewport = globalThis.__SSR_VIEWPORT__;
  if (ssrViewport) {
    return { width: ssrViewport.width, height: ssrViewport.height };
  }
  if (typeof window !== "undefined") {
    return { width: window.innerWidth, height: window.innerHeight };
  }
  return { width: 0, height: 0 };
}

export function getIsPhone() {
  const { width, height } = getViewport();
  return isPhoneViewport(width, height);
}
